var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesForecastV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 18.2499V13.5C6.75 13.222 6.47018 12.9967 6.125 12.9967H4.875C4.52982 12.9967 4.25 13.222 4.25 13.5V18.2499",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 18.0955L11.75 10.5C11.75 10.222 11.4719 9.99671 11.1289 9.99671C10.6438 9.99671 10.3718 9.99671 9.88667 9.99671C9.54365 9.99671 9.26557 10.222 9.26557 10.5C9.31976 13.4483 9.21147 15.1473 9.26565 18.0955",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 18.0955V8.75329C16.75 8.47533 16.4702 8.25 16.125 8.25C15.6368 8.25 15.3632 8.25 14.875 8.25C14.5298 8.25 14.25 8.47533 14.25 8.75329V18.0955",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6426 2.26038L12.2317 5.46991C11.8921 5.82092 11.1615 6.69425 10.3746 5.86967L8.82171 4.26457C8.48212 3.91356 7.93154 3.91356 7.59196 4.26457L4.75 7.49981M15.6426 4L15.75 2L13.8165 2.26038",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 1.75V16.3611C1.75 16.8621 1.94901 17.3425 2.30324 17.6968C2.65748 18.051 3.13792 18.25 3.63889 18.25H18.75",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesForecastV2);
export default __webpack_public_path__ + "static/media/salesForecastV2.c8cf5282681f187934e967dc7754b2ce.svg";
export { ForwardRef as ReactComponent };